import React, { Component } from "react";

import { css, StyleSheet } from "aphrodite/no-important";

class Numbers extends Component {
  constructor(props) {
    super(props);

  }

  render () {
    return (
      <div className={css(styles.icon)}>{this.props.number}</div>
    )
  }

}

export default Numbers;

const styles = StyleSheet.create({
  icon: {
    width: '40px',
    height: '40px',
    backgroundColor: '#00A2E0',
    borderRadius: '50px',
    padding: '10px',
    color:'#fff',
    margin:'20px auto'
  }
});



// WEBPACK FOOTER //
// ./src/components/icons/circleNumber.js